module.exports = __webpack_public_path__ + "a6a30211523c99cf2a69a6f8186c62f4.png";